import { auth } from "../firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import Modal from "react-bootstrap/Modal";
import logo from '../images/poetica-westfalia.png';
import aufbrueche from "../images/aufbrueche_Logo_final.png";
import PP_Karte_3 from "../images/PP_poetica-westfalia_3.jpg";
import info from "../images/info_blau.svg";
import Newsletter from '../components/Newsletter';
import { useState, useEffect } from "react";

export default function Home() {

  const [userState, setuserState] = useState(false);
  const [showInfo, setInfo] = useState(false);
  const [showEvents, setEvents] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        setuserState(true)
      }
      else {
        setuserState(false)
      }
    })
  })

  return (
    <div className="page-class">
      <Modal show={showEvents} onHide={() => setEvents(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Aktuelle Veranstaltungen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Präsentation der frisch gedruckten Landkarte mit Lesung und Gespräch:</p>
          <p>27. Mai 2025, 18 Uhr<br />
            cuba cultur, Achtermannstr. 10-12, 48143 Münster<br />
            Eintritt frei</p>
          <p>28. Mai 2025, 17 Uhr<br />
            Gemeindebücherei Steinhagen, Kirchplatz 26a, 33803 Steinhagen<br />
            Eintritt frei</p>
          <p>Jahrunderte alt und gottergeben auf Torbögen geschnitzt, mit Inbrunst und flüchtig auf Betonmauern gesprüht, staatlich gefördert auf Fassaden, auf Mülltonnen geschrieben gegen weggeworfene Gedanken: so zeigt sich die Poesie im öffentlichen Raum in Westfalen. Menschen haben sie erspäht und zusammengetragen, poetische Ballungsräume erzeugt und lyrisches Brachland, unter dem sich vielleicht noch nicht gehobene Schätze verbergen. poetica westfalia ist eine Momentaufnahme von Orten, an denen sich Raum, Zeit und Text zu Poesie verbinden, scheinbar zufällig und doch den geheimen Regeln der Kunst folgend. Oft reicht ein Wort und ein Material, um Eindruck zu erzeugen, fröhlich zu stimmen oder nachdenklich.<br />
            poetica westfalia ist die Landkarte für deine Entdeckungsreise durch einen Landstrich, der hier selbst zum Autor wird, zur Dichterin – mal einsilbig und wortkarg wie der Menschenschlag hier, mal kernig wie das Schwarzbrot, mal ausufernd wie ein Schützenfest.
          </p>
        </Modal.Body>
      </Modal>
      <img src={logo} alt="logo" className='img-fluid' />
      <p className="signifier">Eine lyrische Spurensuche für alle in Westfalen: Fahndet in Stadt und Land nach Gedichten, Lyrik, Versen und Worten. </p>
      {userState ? <a href='/post' className='btn btn-primary mb-5 mt-3'>Direkt Poem melden</a> : <div className="mb-5 mt-3"><a href='/login' className='btn btn-primary'>Direkt zum Login</a><img src={info} className="info-icon" alt="" onClick={() => setInfo(true)} /></div>}
      <Modal show={showInfo} onHide={() => setInfo(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>Eine Anmeldung mit E-Mail und Passwort ist nötig, um unsere App vor unerlaubtem Zugriff zu schützen. Deine Daten werden verschlüsselt gespeichert und nicht an Dritte weitergegeben.
        </Modal.Body>
      </Modal>
      <h2>Der gedruckte Faltplan ist da!</h2>
      <img src={PP_Karte_3} alt="Karte" className="img-fluid" />
      <p><a href='https://www.primapublikationen.com/publikation/poetica-westfalia-eine-poetische-landkarte-westfalens/' target="_blank" rel="noreferrer" className='btn btn-primary mb-5 mt-3'>Hier kaufen</a></p>
      <p>Jahrunderte alt und gottergeben auf Torbögen geschnitzt, mit Inbrunst und flüchtig auf Betonmauern gesprüht, staatlich gefördert auf Fassaden, auf Mülltonnen geschrieben gegen weggeworfene Gedanken: so zeigt sich die Poesie im öffentlichen Raum in Westfalen. Menschen haben sie erspäht und zusammengetragen, poetische Ballungsräume erzeugt und lyrisches Brachland, unter dem sich vielleicht noch nicht gehobene Schätze verbergen. poetica westfalia ist eine Momentaufnahme von Orten, an denen sich Raum, Zeit und Text zu Poesie verbinden, scheinbar zufällig und doch den geheimen Regeln der Kunst folgend. Oft reicht ein Wort und ein Material, um Eindruck zu erzeugen, fröhlich zu stimmen oder nachdenklich.<br />
        poetica westfalia ist die Landkarte für deine Entdeckungsreise durch einen Landstrich, der hier selbst zum Autor wird, zur Dichterin – mal einsilbig und wortkarg wie der Menschenschlag hier, mal kernig wie das Schwarzbrot, mal ausufernd wie ein Schützenfest.
      </p>
      <br />
      <p>Du willst nichts verpassen? <br />Abonniere unseren Newsletter:</p>

      <Newsletter />
      <br /><br />
      <p>poetica westfalia ist Teil von</p>
      <img src={aufbrueche} alt="Aufbrüche" className='img-fluid w-75' />
    </div>
  )
}